import classNames from "clsx";
import { type ReactElement, useMemo } from "react";
import { camelCase } from "es-toolkit";
import { type BaseElementProps } from "../../../types/Element";
import * as icons from "./A2Icon.imports";
import styles from "./A2Icon.module.scss";

// List of all the icons imported from "A2Icon.imports". Need a new icon, add it to the imports there
export type A2IconName = keyof typeof icons;

export type A2IconProps = Omit<BaseElementProps<"span">, "children"> & {
  name: A2IconName;
};

export function A2Icon({
  name,
  className,
  ...restProps
}: A2IconProps): ReactElement {
  // @ts-expect-error - Import based on icon name
  const Component = useMemo(() => icons?.[camelCase(name)] ?? null, [name]);

  return (
    <span className={classNames(styles.a2Icon, className)} {...restProps}>
      <Component />
    </span>
  );
}
